import Vue from 'vue'
import {library} from '@fortawesome/fontawesome-svg-core'
import {
    faArrowsAlt,
    faBars,
    faBell,
    faBirthdayCake,
    faCheck,
    faChevronCircleLeft,
    faChevronCircleRight,
    faChevronDown,
    faChevronLeft,
    faChevronRight,
    faChevronUp,
    faDumbbell,
    faTimes,
    faUserFriends,
    faListOl,
    faSquare,
    faTrophy,
    faCaretDown,
    faPowerOff,
    faCaretLeft,
    faCaretRight
} from '@fortawesome/free-solid-svg-icons'
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome'

library.add(
    faBars,
    faChevronLeft,
    faChevronRight,
    faChevronUp,
    faChevronDown,
    faChevronCircleLeft,
    faChevronCircleRight,
    faCheck,
    faTimes,
    faBirthdayCake,
    faDumbbell,
    faBell,
    faArrowsAlt,
    faUserFriends,
    faUserFriends,
    faListOl,
    faSquare,
    faTrophy,
    faCaretDown,
    faPowerOff,
    faCaretLeft,
    faCaretRight)

Vue.component('fas', FontAwesomeIcon)

